var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"hiq-detail-planning-list__selected-filters-wrapper"},[(_vm.selectedFilters.length > 0)?_c('button',{staticClass:"hiq-detail-planning-list__selected-filters-clear-button",on:{"click":_vm.deselectAllFilters}},[_vm._v(" "+_vm._s(_vm.translations.clearAllFilters)+" ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }